module.exports = __webpack_public_path__ + "20221216:03503e97ddf972ec7716/img/hero-title-img@1x.43234a1.png";